import React from 'react'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Link from '../utils/link'
import usePostsQuery from '../hooks/use-posts-query'
import JournalFilter from './journal-filter'
import sal from 'sal.js'

const JournalArchive = ({title}) => {

  const { posts, categories } = usePostsQuery()

  const [list, setList] = React.useState(posts?.nodes)

  React.useEffect(() => {
    sal()
  }, [list])

  return (
    <>
      <JournalFilter 
        title={title}
        categories={categories}
        list={posts?.nodes || []}
        set={setList}
      />
      <section className='featured-projects featured-projects--archive'>
        <div className='featured-projects__inner'>
          { list?.length &&
            <div className='featured-projects__items'>
              { list?.map((el, i) => {
                let image = el.acf?.thumbnail?.landscapeImage?.localFile
                if ((i + 1) % 2 === 0) image = el.acf?.thumbnail?.portraitImage?.localFile
                return (
                  <Link key={i} to={`/article/${el.slug}/`} className='featured-projects__item'  data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease'>
                    <GatsbyImage image={getImage(image)} alt={el.acf?.thumbnail?.landscapeImage?.altText} />
                    <div className='featured-projects__cap'>
                      { el.title && <h4>{parse(el.title)}</h4> }
                      { el.acf?.excerpt && <p>{parse(el.acf.excerpt)}</p> }
                    </div>
                  </Link>
                )
              })}
            </div>
          }
        </div>
      </section>
    </>
  )
}

export default JournalArchive